import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: "logisticCostDialog",
  props: {
    loggedUserData: Object,
    title: {
      type: String,
      default: "Location"
    },
    listCountries: {
      type: Array,
      default: []
    },
    listStates: {
      type: Array,
      default: []
    },
    confirm: Function,
    cancel: Function,
    dialog: Boolean
  },
  data: function data() {
    return {
      isValidating: false,
      options: {
        color: "primary",
        width: 600,
        zIndex: 2000
      },
      form: {
        countryId: null,
        stateId: null
      },
      displayedListStates: []
    };
  },
  computed: {
    isInvalidForm: function isInvalidForm() {
      var nullishPredicate = function nullishPredicate(x) {
        return !x.countryId;
      };
      if (nullishPredicate(this.form)) return true;
      return false;
    }
  },
  methods: {
    generateStatesList: function generateStatesList() {
      this.displayedListStates = [];
      if (this.form.countryId) {
        for (var state in this.listStates) {
          if (this.listStates[state].id_country === this.form.countryId) {
            this.displayedListStates.push(this.listStates[state]);
          }
        }
      }
    },
    agree: function agree() {
      var _this2 = this;
      this.isValidating = true;
      var country = this.listCountries.filter(function (x) {
        return x.id_country === _this2.form.countryId;
      })[0];
      var label = country.continent_iso_2 + " - " + country.printable_name;
      if (this.form.stateId) {
        var state = this.listStates.filter(function (x) {
          return x.id_state === _this2.form.stateId;
        })[0];
        label += " - " + state.state_label;
      } else if (this.listStates.some(function (x) {
        return x.id_country == _this2.form.countryId;
      })) {
        label += " (default)";
      }
      var _this = this;
      return this.confirm(country.continent_iso_2, this.form.countryId, this.form.stateId, label).then(function () {
        _this.isValidating = false;
      }).catch(function (e) {
        var _e$response;
        if (e !== null && e !== void 0 && (_e$response = e.response) !== null && _e$response !== void 0 && _e$response.data) {
          _this.$toasted.show(e.response.data.value, {
            type: "warning"
          });
        }
        _this.isValidating = false;
      });
    },
    internalCancel: function internalCancel() {
      this.cancel();
    }
  }
};